import Vue from 'vue';
import './ie10hacks';
import 'whatwg-fetch';
import './setupVuePlugins';
import App from './App.vue';

Vue.config.productionTip = false;
// Placeholder here: Anything that needs config BEFORE the app_config is loaded,
// Configure it here, and get settings from the manifest.json.
// import manifest from '../manifest.json';

export default () => {
    new Vue({
        render: h => h(App)
    }).$mount('#community-profiles-viz');
};
